import { i18n } from '@lingui/core'
import dayjs from 'dayjs'

// Import dayjs locales
import 'dayjs/locale/es'
import 'dayjs/locale/fi'

// Import .po files directly - Vite plugin compiles them at build time
import { messages as enMessages } from '../locales/en/messages.po'
import { messages as esMessages } from '../locales/es/messages.po'
import { messages as fiMessages } from '../locales/fi/messages.po'

export const locales = {
  en: 'English',
  fi: 'Suomi',
  es: 'Español',
}

export type Locale = keyof typeof locales

const LOCALE_KEY = 'markku_locale'

function getInitialLocale(): Locale {
  const stored = localStorage.getItem(LOCALE_KEY)
  if (stored && stored in locales) {
    return stored as Locale
  }
  // Could also check navigator.language here
  return 'fi' // Default to Finnish
}

i18n.load({
  en: enMessages,
  fi: fiMessages,
  es: esMessages,
})

export function setLocale(locale: Locale) {
  localStorage.setItem(LOCALE_KEY, locale)
  i18n.activate(locale)
  dayjs.locale(locale)
}

// Initialize with stored/default locale
setLocale(getInitialLocale())

export { i18n }
